import { FC } from "react";
import { GetTypographyContent } from "../shared/Typography/Typography";
import {
  CreateAccountPasswordRequirmentsContainer,
  CreateAccountPasswordRequirmentsTitle,
  CreateAccountStyledCheckMark,
} from "./CreateAccountForm.styles";

interface CreateAccountPasswordInfoProps {
  isPw8Chars: boolean;
  isPwUpperChar: boolean;
  isPwLowerChar: boolean;
  isPwDigit: boolean;
  doPasswordsMatch?: boolean;
  showPasswordMatch?: boolean;
}

export const CreateAccountPasswordInfo: FC<CreateAccountPasswordInfoProps> = ({
  isPw8Chars,
  isPwUpperChar,
  isPwLowerChar,
  isPwDigit,
  doPasswordsMatch,
  showPasswordMatch = true,
}) => (
  <CreateAccountPasswordRequirmentsTitle>
    {GetTypographyContent({
      content: "To ensure that account is well protected, avoid common",
      size: "medium",
      isBold: true,
      textColor: "greyMedium",
    })}
    {GetTypographyContent({
      content: "words, names, dates and repeating characters.",
      size: "medium",
      isBold: true,
      textColor: "greyMedium",
    })}
    <CreateAccountPasswordRequirmentsContainer>
      {showPasswordMatch && (
        <>
          <CreateAccountStyledCheckMark $valid={Boolean(doPasswordsMatch)} />
          {GetTypographyContent({
            content: "Passwords match",
            size: "small",
            textColor: "neutral700",
          })}
        </>
      )}
      <CreateAccountStyledCheckMark $valid={isPw8Chars} />
      {GetTypographyContent({
        content: "Contain at least 8 characters",
        size: "small",
        textColor: "neutral700",
      })}
      <CreateAccountStyledCheckMark $valid={isPwUpperChar} />
      {GetTypographyContent({
        content: "Contain an uppercase letter",
        size: "small",
        textColor: "neutral700",
      })}
      <CreateAccountStyledCheckMark $valid={isPwLowerChar} />
      {GetTypographyContent({
        content: "Contain a lowercase letter",
        size: "small",
        textColor: "neutral700",
      })}
      <CreateAccountStyledCheckMark $valid={isPwDigit} />
      {GetTypographyContent({
        content: "Contain a number",
        size: "small",
        textColor: "neutral700",
      })}
    </CreateAccountPasswordRequirmentsContainer>
  </CreateAccountPasswordRequirmentsTitle>
);
